import React from 'react';

function AEDIcon({ fill, ...restProps }) {
  return (
    <svg
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M2.2 1.65c.012.02.062.093.112.163.166.233.296.584.398 1.077.043.207.051.447.06 1.724l.01 1.482-.674-.011c-.765-.013-.85-.03-1.068-.222a.802.802 0 0 0-.143-.111c-.009 0-.017.122-.017.271 0 .568.273 1.04.723 1.25.163.076.191.08.673.089l.503.009v1.271H2.1c-.762 0-.8-.008-1.077-.227a1.83 1.83 0 0 0-.151-.113c-.004 0-.004.124.001.276.019.625.314 1.104.79 1.282.124.046.252.061.636.076l.481.018-.011 1.518c-.01 1.276-.019 1.553-.059 1.731-.099.452-.249.821-.428 1.055a.826.826 0 0 0-.1.152c0 .011 1.208.012 2.684.003 3.166-.02 3.42-.036 4.385-.288 1.234-.323 2.072-.788 2.827-1.572a5.332 5.332 0 0 0 1.238-2.126c.065-.211.131-.414.146-.451l.028-.068.77.017c.87.02.953.036 1.163.22a.86.86 0 0 0 .143.112c.037 0 .011-.507-.035-.683a1.311 1.311 0 0 0-.679-.839c-.156-.077-.178-.079-.678-.088l-.517-.009V7.367h.665c.757 0 .828.014 1.107.225l.154.117v-.245c0-.576-.263-1.054-.703-1.277-.16-.081-.165-.081-.742-.089-.645-.009-.708-.016-.708-.081 0-.163-.305-.975-.515-1.37-.913-1.718-2.636-2.747-5.003-2.988C7.333 1.6 2.165 1.592 2.2 1.65m5.429.655c1.78.255 2.853 1.133 3.404 2.785.118.357.251.949.219.981-.011.011-1.486.018-3.278.014l-3.257-.008-.007-1.923-.007-1.923 1.311.016c.958.011 1.392.026 1.615.058m3.789 5.699v.638H4.703V7.367h6.715v.637M11.248 10c0 .128-.182.813-.292 1.097-.518 1.341-1.45 2.16-2.832 2.488-.627.149-.803.164-2.153.177l-1.268.013v-3.83l2.912-.007a640.2 640.2 0 0 0 3.272-.014l.361-.007V10'
        fill={fill ?? ''}
        fill-rule='evenodd'
      />
    </svg>
  );
}

export default AEDIcon;
